import { Em, SectionHead, tableWrap, td, th, tr } from './primitives'

/**
 * From the desktop app's model catalog (apollo engine/catalog-entries.mjs and
 * models-catalog.mjs). Sizes are download sizes; "needs" is the catalog's minimum
 * memory. Starred rows are the wizard's recommended picks.
 */
const MODELS = [
  { name: 'Z-Image Turbo', kind: 'image', size: '12.3 GB', needs: '24 GB', note: 'Fast local default · 5 GB GGUF from 12 GB', rec: true },
  { name: 'FLUX.2 klein 4B', kind: 'edit', size: '7.8 GB', needs: '16 GB', note: 'Generate and edit with words', rec: true },
  { name: 'Stable Diffusion 1.5', kind: 'image', size: '2.1 GB', needs: '8 GB', note: 'Runs on any Apple Silicon Mac', rec: true },
  { name: 'SeedVR2 3B', kind: 'upscale', size: '6.8 GB', needs: '16 GB', note: 'Photos and video', rec: true },
  { name: 'BiRefNet', kind: 'cutout', size: '444 MB', needs: '8 GB', note: 'Background removal', rec: true },
  { name: 'LaMa', kind: 'erase', size: '206 MB', needs: '8 GB', note: 'Instant object eraser', rec: true },
  { name: 'Wan 2.2 5B', kind: 'video', size: '10 GB', needs: '24 GB', note: 'Text or image to 720p video', rec: true },
  { name: 'ACE-Step 1.5', kind: 'music', size: '10 GB', needs: '24 GB', note: 'Music with lyrics', rec: true },
  { name: 'TRELLIS.2', kind: '3D', size: '10.3 GB', needs: '32 GB', note: 'Image to textured mesh · experimental on Mac', rec: false },
] as const

export function LocalModels() {
  return (
    <section id="models" className="landing-shell scroll-mt-20 pt-28">
      <SectionHead
        eyebrow="Models"
        title={
          <>
            Open weights, <Em>on your disk</Em>
          </>
        }
        note="The setup wizard reads chip, memory and free disk, then preselects the recommended models that fit, leaving 20 GB free. The rest are one click in the model library."
      />
      <div className={tableWrap}>
        <table className="w-full min-w-[640px] border-collapse text-left">
          <thead>
            <tr>
              <th className={th}>Model</th>
              <th className={th}>Kind</th>
              <th className={`${th} text-right`}>Weights</th>
              <th className={`${th} text-right`}>Needs</th>
              <th className={th}>Note</th>
            </tr>
          </thead>
          <tbody>
            {MODELS.map((m) => (
              <tr key={m.name} className={`${tr} transition-colors hover:bg-canvas`}>
                <td className={td}>
                  <span className="inline-flex items-center gap-2.5">
                    <span
                      className={`inline-block size-2 rounded-full ${
                        m.rec ? 'bg-lamp' : 'border border-rule-strong'
                      }`}
                      aria-hidden
                    />
                    <span className="text-[15px] text-ink">{m.name}</span>
                  </span>
                </td>
                <td className={`${td} mono-label text-ink-3`}>{m.kind}</td>
                <td className={`${td} num text-right text-[13px]`}>{m.size}</td>
                <td className={`${td} num text-right text-[13px] text-ink-2`}>{m.needs}</td>
                <td className={`${td} text-[13px] text-ink-2`}>{m.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mono-label mt-3 text-ink-3">
        <span className="mr-1.5 inline-block size-2 rounded-full bg-lamp align-middle" aria-hidden /> Recommended
        pick · needs = minimum memory · shared text encoders add up to 8 GB
      </p>
    </section>
  )
}
